class FeaturedCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
    this.prevBtn = this.querySelector('[data-carousel-prev]');
    this.nextBtn = this.querySelector('[data-carousel-next]');
    this.index = 0;
    this.autoplayDelay = 5000;

    if (this.slides.length <= 1) return;

    this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
    this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.startAutoplay();
  }

  go(newIndex) {
    const total = this.slides.length;
    this.index = (newIndex + total) % total;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.go(this.index + 1), this.autoplayDelay);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

customElements.define('featured-carousel', FeaturedCarousel);
